import script from "./topRightCard1.vue?vue&type=script&setup=true&lang=js"
export * from "./topRightCard1.vue?vue&type=script&setup=true&lang=js"

import "./topRightCard1.vue?vue&type=style&index=0&id=8b6ffffa&scoped=true&lang=css"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b6ffffa"]])

export default __exports__